import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from "react";
import filter from 'lodash/filter';
import TabPanel from "../TabPanel";
var TabsContainer = function TabsContainer(_ref) {
  var _ref$activeTab = _ref.activeTab,
    activeTab = _ref$activeTab === void 0 ? '' : _ref$activeTab,
    _ref$onTabChange = _ref.onTabChange,
    onTabChange = _ref$onTabChange === void 0 ? function () {} : _ref$onTabChange,
    children = _ref.children,
    _ref$styler = _ref.styler,
    styler = _ref$styler === void 0 ? {
      display: "flex"
    } : _ref$styler,
    _ref$progressAnimatio = _ref.progressAnimation,
    progressAnimation = _ref$progressAnimatio === void 0 ? false : _ref$progressAnimatio;
  var _useState = useState(activeTab),
    _useState2 = _slicedToArray(_useState, 2),
    currentActiveTab = _useState2[0],
    setActivetab = _useState2[1];
  var _useState3 = useState(getActiveTabContent(activeTab)),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTabContent = _useState4[0],
    setActivetabContent = _useState4[1];
  var changeTab = useCallback(function (tab) {
    var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setActivetab(tab);
    onTabChange && onTabChange(tab, event);
  }, [onTabChange, setActivetab]);
  var _useState5 = useState(getDescendents(children, activeTab, changeTab, progressAnimation)),
    _useState6 = _slicedToArray(_useState5, 2),
    descendents = _useState6[0],
    setDescendents = _useState6[1];
  function getActiveTabContent(tab) {
    var childArr = React.Children.toArray(children);
    var activeTabID = '';
    var _filter = filter(childArr, function (child) {
        var isActive = child.props.tabID === tab;
        var disabled = child.props.disabled;
        activeTabID = isActive ? child.props.tabID : activeTabID;
        return isActive && !disabled;
      }),
      _filter2 = _slicedToArray(_filter, 1),
      activeTab = _filter2[0];
    var activeTabChildren = activeTab && activeTab.props && activeTab.props.children || [];
    var activeTabChildrenArr = React.Children.toArray(activeTabChildren);
    var _filter3 = filter(activeTabChildrenArr, function (child) {
        return child.type && child.type === TabPanel;
      }),
      _filter4 = _slicedToArray(_filter3, 1),
      _filter4$ = _filter4[0],
      content = _filter4$ === void 0 ? false : _filter4$;
    return content ? /*#__PURE__*/React.cloneElement(content, {
      tabID: activeTabID
    }) : null;
  }
  function getDescendents(children, activeTab, changeTab) {
    var progressAnimation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var result = React.Children.map(children, function (child) {
      return /*#__PURE__*/React.cloneElement(child, {
        activeTab: activeTab,
        changeTab: changeTab,
        progressAnimation: progressAnimation
      });
    });
    return result;
  }
  useEffect(function () {
    setActivetab(activeTab);
  }, [activeTab]);
  useEffect(function () {
    if (currentActiveTab) {
      setActivetabContent(getActiveTabContent(currentActiveTab));
    }
  }, [currentActiveTab]);
  useEffect(function () {
    var tab = currentActiveTab || activeTab;
    var descendents = getDescendents(children, tab, changeTab, progressAnimation);
    if (descendents) {
      setDescendents(descendents);
    }
  }, [children, activeTab, currentActiveTab, progressAnimation, changeTab]);
  return /*#__PURE__*/React.createElement("div", {
    className: "progrssive-tabs-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    style: styler
  }, descendents), activeTabContent);
};
export default TabsContainer;